function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { deleteManagedChannel, getChannelByName, getChannels } from '@/actions/ChannelActions';
import { createManager, deleteManager, getManagers } from '@/actions/UserActions';
import useAppStore from '@/stores/AppStore';
import useAuthenticationStore from '@/stores/AuthenticationStore';
import { faCode, faIdCardClip, faLanguage, faMoon, faTrash } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import SettingsPanel from '../SettingsPanel';
import Table from '../Table';
import dayjs from 'dayjs';
import InputModal, { DefaultInput } from '../InputModal';
import useChannelStore from '@/stores/ChannelStore';
import { useShallow } from 'zustand/react/shallow';
import { ActionIcon, Avatar, Button, Table as MantineTable, Select, Switch, Text } from '@mantine/core';
import TableHeading from '../TableHeading';
import styles from './GeneralPanel.module.scss';
import Icon, { IconSizes } from '../Icon';
import { useDisclosure } from '@mantine/hooks';
import Heading from '../Heading';
import { CopyIconButton } from '../CopyTextButton';
function ManagerSection(param) {
    var managers = param.managers, _param_removeManagerModal = _sliced_to_array(param.removeManagerModal, 2), removeManagerModalHandlers = _param_removeManagerModal[1], _param_addManagerModal = _sliced_to_array(param.addManagerModal, 2), addManagerModalHandlers = _param_addManagerModal[1], setSelectedManager = param.setSelectedManager;
    var intl = useIntl();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "i4AQpn",
                    defaultMessage: "Managers"
                })
            }),
            /*#__PURE__*/ _jsx(Table, {
                data: managers,
                extraData: [
                    removeManagerModalHandlers.open
                ],
                renderHeader: function() {
                    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
                        children: [
                            /*#__PURE__*/ _jsx(TableHeading, {
                                visibleFrom: "sm",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "wNCvfg",
                                    defaultMessage: "Added On"
                                })
                            }),
                            /*#__PURE__*/ _jsx(TableHeading, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "KQzcqr",
                                    defaultMessage: "Manager"
                                })
                            }),
                            /*#__PURE__*/ _jsx(TableHeading, {
                                visibleFrom: "sm",
                                alignRight: true,
                                className: styles.actionsHeader,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "wL7VAE",
                                    defaultMessage: "Actions"
                                })
                            })
                        ]
                    });
                },
                renderRow: function(manager) {
                    var onRemoveManager = function onRemoveManager() {
                        setSelectedManager(manager);
                        removeManagerModalHandlers.open();
                    };
                    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
                        children: [
                            /*#__PURE__*/ _jsx(MantineTable.Td, {
                                className: styles.createdAtColumn,
                                visibleFrom: "sm",
                                children: dayjs(manager.createdAt).format('MMM D, YYYY')
                            }),
                            /*#__PURE__*/ _jsx(MantineTable.Td, {
                                className: styles.managerColumn,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: styles.managerInfo,
                                    children: [
                                        /*#__PURE__*/ _jsx(Avatar, {
                                            size: "sm",
                                            src: manager.user.avatar
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            size: "sm",
                                            className: styles.truncated,
                                            children: manager.user.displayName
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(MantineTable.Td, {
                                className: styles.actionsColumn,
                                children: /*#__PURE__*/ _jsx(ActionIcon, {
                                    size: "sm",
                                    "aria-label": intl.formatMessage({
                                        id: "l+zVwn",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Remove Manager"
                                            }
                                        ]
                                    }),
                                    onClick: onRemoveManager,
                                    children: /*#__PURE__*/ _jsx(Icon, {
                                        size: IconSizes.SM,
                                        icon: faTrash
                                    })
                                })
                            })
                        ]
                    });
                },
                renderEmptyState: function() {
                    return /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "0Zuxfl",
                        defaultMessage: "No managers"
                    });
                }
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.addManagerButton,
                children: /*#__PURE__*/ _jsx(Button, {
                    size: "sm",
                    onClick: addManagerModalHandlers.open,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "xqHZYI",
                        defaultMessage: "Add Manager"
                    })
                })
            })
        ]
    });
}
function ManagedChannelsSection(param) {
    var managedChannels = param.managedChannels, _param_removeManagedChannelModal = _sliced_to_array(param.removeManagedChannelModal, 2), removeManagedChannelModalHandlers = _param_removeManagedChannelModal[1], setSelectedManagedChannelId = param.setSelectedManagedChannelId;
    var intl = useIntl();
    if (managedChannels == null || managedChannels.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "1phEWs",
                    defaultMessage: "Managed Channels"
                })
            }),
            /*#__PURE__*/ _jsx(Table, {
                data: managedChannels,
                extraData: [
                    removeManagedChannelModalHandlers.open
                ],
                renderHeader: function() {
                    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
                        children: [
                            /*#__PURE__*/ _jsx(TableHeading, {
                                visibleFrom: "sm",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "wNCvfg",
                                    defaultMessage: "Added On"
                                })
                            }),
                            /*#__PURE__*/ _jsx(TableHeading, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "KQzcqr",
                                    defaultMessage: "Manager"
                                })
                            }),
                            /*#__PURE__*/ _jsx(TableHeading, {
                                visibleFrom: "sm",
                                alignRight: true,
                                className: styles.actionsHeader,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "wL7VAE",
                                    defaultMessage: "Actions"
                                })
                            })
                        ]
                    });
                },
                renderRow: function(managedChannel) {
                    var onRemoveManagedChannel = function onRemoveManagedChannel() {
                        setSelectedManagedChannelId(managedChannel._id);
                        removeManagedChannelModalHandlers.open();
                    };
                    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
                        children: [
                            /*#__PURE__*/ _jsx(MantineTable.Td, {
                                visibleFrom: "sm",
                                className: styles.createdAtColumn,
                                children: dayjs(managedChannel.createdAt).format('MMM D, YYYY')
                            }),
                            /*#__PURE__*/ _jsx(MantineTable.Td, {
                                className: styles.managerColumn,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: styles.managerInfo,
                                    children: [
                                        /*#__PURE__*/ _jsx(Avatar, {
                                            size: "sm",
                                            src: managedChannel.channel.avatar
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            size: "sm",
                                            className: styles.truncated,
                                            children: managedChannel.channel.displayName
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(MantineTable.Td, {
                                className: styles.actionsColumn,
                                children: /*#__PURE__*/ _jsx(ActionIcon, {
                                    size: "sm",
                                    "aria-label": intl.formatMessage({
                                        id: "9OOG92",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Remove Managed Channel"
                                            }
                                        ]
                                    }),
                                    onClick: onRemoveManagedChannel,
                                    children: /*#__PURE__*/ _jsx(Icon, {
                                        size: IconSizes.SM,
                                        icon: faTrash
                                    })
                                })
                            })
                        ]
                    });
                }
            })
        ]
    });
}
function GeneralPanel() {
    var user = useAuthenticationStore(function(state) {
        return state.user;
    });
    var _useAppStore = useAppStore(useShallow(function(state) {
        return {
            colorMode: state.colorMode,
            toggleColorMode: state.toggleColorMode,
            isDeveloper: state.isDeveloper,
            setIsDeveloper: state.setIsDeveloper
        };
    })), colorMode = _useAppStore.colorMode, toggleColorMode = _useAppStore.toggleColorMode, isDeveloper = _useAppStore.isDeveloper, setIsDeveloper = _useAppStore.setIsDeveloper;
    var _useChannelStore = useChannelStore(useShallow(function(state) {
        return {
            managedChannels: state.managedChannels,
            managedChannelsLoading: state.managedChannelsLoading
        };
    })), managedChannels = _useChannelStore.managedChannels, managedChannelsLoading = _useChannelStore.managedChannelsLoading;
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(null), 2), managers = _React_useState[0], setManagers = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(null), 2), selectedManager = _React_useState1[0], setSelectedManager = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(null), 2), selectedManagedChannelId = _React_useState2[0], setSelectedManagedChannelId = _React_useState2[1];
    var addManagerModal = useDisclosure();
    var removeManagerModal = useDisclosure();
    var removeManagedChannelModal = useDisclosure();
    React.useEffect(function() {
        if (managedChannelsLoading || managedChannels != null) {
            return;
        }
        getChannels();
    }, [
        managedChannels,
        managedChannelsLoading
    ]);
    React.useEffect(function() {
        getManagers().then(function(managers) {
            return setManagers(managers);
        }).catch(console.error);
    }, []);
    var addManager = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(username) {
            var manager, _, channelUser, manager1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (managers == null || user == null) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            createManager(username)
                        ];
                    case 2:
                        manager = _state.sent();
                        setManagers(_to_consumable_array(managers).concat([
                            manager
                        ]));
                        return [
                            2
                        ];
                    case 3:
                        _ = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            4,
                            getChannelByName(user.provider, username)
                        ];
                    case 5:
                        channelUser = _state.sent();
                        if (channelUser == null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            createManager(channelUser._id)
                        ];
                    case 6:
                        manager1 = _state.sent();
                        setManagers(_to_consumable_array(managers).concat([
                            manager1
                        ]));
                        return [
                            2
                        ];
                }
            });
        });
        return function(username) {
            return _ref.apply(this, arguments);
        };
    }(), [
        managers,
        user
    ]);
    var removeManager = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (selectedManager == null || managers == null) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        deleteManager(selectedManager._id)
                    ];
                case 1:
                    _state.sent();
                    setManagers(managers.filter(function(manager) {
                        return manager._id !== selectedManager._id;
                    }));
                    return [
                        2
                    ];
            }
        });
    }), [
        selectedManager,
        managers
    ]);
    var removeManagedChannel = React.useCallback(function() {
        if (managedChannels == null || selectedManagedChannelId == null) {
            return;
        }
        deleteManagedChannel(selectedManagedChannelId);
    }, [
        managedChannels,
        selectedManagedChannelId
    ]);
    var _addManagerModal = _sliced_to_array(addManagerModal, 2), addManagerModalOpen = _addManagerModal[0], addManagerModalHandlers = _addManagerModal[1];
    var _removeManagerModal = _sliced_to_array(removeManagerModal, 2), removeManagerModalOpen = _removeManagerModal[0], removeManagerModalHandlers = _removeManagerModal[1];
    var _removeManagedChannelModal = _sliced_to_array(removeManagedChannelModal, 2), removeManagedChannelModalOpen = _removeManagedChannelModal[0], removeManagedChannelModalHandlers = _removeManagedChannelModal[1];
    var _user__id, _user__id1;
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "2GURQY",
                    defaultMessage: "Appearance"
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                icon: faIdCardClip,
                heading: intl.formatMessage({
                    id: "55vTH+",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "User ID"
                        }
                    ]
                }),
                description: (_user__id = user === null || user === void 0 ? void 0 : user._id) !== null && _user__id !== void 0 ? _user__id : '',
                afterElement: /*#__PURE__*/ _jsx(CopyIconButton, {
                    buttonProps: {
                        size: 'lg'
                    },
                    value: (_user__id1 = user === null || user === void 0 ? void 0 : user._id) !== null && _user__id1 !== void 0 ? _user__id1 : '',
                    hoverText: intl.formatMessage({
                        id: "/bcTh9",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Copy User ID"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                icon: faMoon,
                heading: intl.formatMessage({
                    id: "5ObBlW",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Dark Mode"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "Uzzhfy",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Toggle dark mode"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Switch, {
                    checked: colorMode === 'dark',
                    onChange: toggleColorMode
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                icon: faLanguage,
                heading: intl.formatMessage({
                    id: "y1Z3or",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Language"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "D7boVt",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Change the language of the dashboard"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Select, {
                    variant: "filled",
                    size: "sm",
                    disabled: true,
                    placeholder: "English"
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                icon: faCode,
                heading: intl.formatMessage({
                    id: "Vj/RCG",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Developer Mode"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "LsgiJr",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Toggle developer mode, to access advanced features"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Switch, {
                    checked: isDeveloper,
                    onChange: function() {
                        return setIsDeveloper(!isDeveloper);
                    }
                })
            }),
            /*#__PURE__*/ _jsx(ManagerSection, {
                managers: managers,
                addManagerModal: addManagerModal,
                removeManagerModal: removeManagerModal,
                setSelectedManager: setSelectedManager
            }),
            /*#__PURE__*/ _jsx(ManagedChannelsSection, {
                managedChannels: managedChannels,
                removeManagedChannelModal: removeManagedChannelModal,
                setSelectedManagedChannelId: setSelectedManagedChannelId
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: addManagerModalOpen,
                onClose: addManagerModalHandlers.close,
                title: intl.formatMessage({
                    id: "xqHZYI",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Add Manager"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "maMaOM",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter the username or ID of the user you would like to add as a manager."
                        }
                    ]
                }),
                submitText: intl.formatMessage({
                    id: "2/2yg+",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Add"
                        }
                    ]
                }),
                onSubmit: addManager,
                renderInput: function(inputProps) {
                    return /*#__PURE__*/ _jsx(DefaultInput, _object_spread({
                        placeholder: intl.formatMessage({
                            id: "azRh27",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Username or ID"
                                }
                            ]
                        })
                    }, inputProps));
                }
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: removeManagerModalOpen,
                onClose: removeManagerModalHandlers.close,
                title: intl.formatMessage({
                    id: "l+zVwn",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Remove Manager"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "fjDa1k",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to remove this user as a manager?"
                        }
                    ]
                }),
                submitText: intl.formatMessage({
                    id: "G/yZLu",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Remove"
                        }
                    ]
                }),
                onSubmit: removeManager
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: removeManagedChannelModalOpen,
                onClose: removeManagedChannelModalHandlers.close,
                title: intl.formatMessage({
                    id: "9OOG92",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Remove Managed Channel"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "TmPWwJ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to remove this channel?"
                        }
                    ]
                }),
                submitText: intl.formatMessage({
                    id: "G/yZLu",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Remove"
                        }
                    ]
                }),
                onSubmit: removeManagedChannel
            })
        ]
    });
}
export default GeneralPanel;
